<template>
  <div>
    <details-modal
      :show="show"
      :current-operation="currentOperation"
      @close="closeModal"
      @cancel="closeModal"
      @create="createMocButtonClicked"
      @delete="deleteMocButtonClicked"
      @update="updateMocButtonClicked"
    >
      <form class="text-left">
        <mean-of-communication-select
          v-validate="'required'"
          v-model="meanOfTelecom.mocId"
          @inputName="checkOrUncheckPublicCheckbox"
          :disabled="currentOperation == 'edit'"
          title="Moyen de communication *"
          data-vv-scope="formMoCDetails"
          name="moyen de communication"
          required
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formMoCDetails.moyen de communication`) }}
        </div>
        <fg-input
          v-validate="'required'"
          v-if="isMocOfPersonType"
          v-model="meanOfTelecom.type"
          :disabled="currentOperation == 'edit'"
          type="text"
          label="Type"
          data-vv-scope="formMoCDetails"
          name="type"
          required
        />
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formMoCDetails.type`) }}
        </div>
        <fg-input
          v-validate="'required'"
          v-model="meanOfTelecom.info"
          type="text"
          label="Valeur"
          data-vv-scope="formMoCDetails"
          name="valeur"
          required
        />
        <p-checkbox
          v-if="isMocOfPersonType"
          v-model="meanOfTelecom.isDisplayedInPublicCommitteesList"
          >Affiché dans la liste des commissions publiques</p-checkbox
        >
        <div v-if="errors.items.length" class="validation-error">
          {{ errors.first(`formMoCDetails.valeur`) }}
        </div>
        <p class="mt-3 mb-0"><label>* champs obligatoires</label></p>
      </form>
      <p v-if="errorMessage" class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import MeanOfCommunicationSelect from 'src/components/ApplicationViews/UIComponents/MeanOfCommunicationSelect.vue';
import DetailsModal from './DetailsModal.vue';

export default {
  components: {
    MeanOfCommunicationSelect,
    DetailsModal,
  },
  props: {
    show: Boolean,
    currentOperation: String,
    meanOfTelecom: Object,
    type: String, // Either "people" or "institutions", will change the URIs and show/hide the "type" and "isDisplayedInPublicCommitteesList" fields.
  },
  data() {
    return {
      personType: 'people',
      errorMessage: '',
    };
  },
  computed: {
    isMocOfPersonType() {
      return this.type === this.personType;
    },
  },
  methods: {
    checkOrUncheckPublicCheckbox(selectedMocName) {
      this.meanOfTelecom.isDisplayedInPublicCommitteesList = selectedMocName.includes(
        'Annuaire',
      );
    },
    createMocButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formMoCDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .post(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/${this.type}/telecominfos/`,
              {
                ...this.meanOfTelecom,
              },
            )
            .then(() => {
              this.closeModal();
            })
            .catch(error => {
              if (error.response.status === 409) {
                this.errorMessage = `L'entité possède déjà ce moyen de communication${
                  this.type === this.personType ? ' et ce type' : ''
                }.`;
              } else {
                this.errorMessage =
                  "Une erreur est survenue lors de l'ajout du moyen de communication, veuillez réessayer ou contacter le support.";
              }
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    updateMocButtonClicked() {
      // Validate that the required field are filled before creating record
      this.$validator.validateAll('formMoCDetails').then(result => {
        if (result) {
          this.errorMessage = null;

          this.$http
            .patch(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/${this.type}/telecominfos/${this.meanOfTelecom.id}`,
              {
                ...this.meanOfTelecom,
              },
            )
            .then(() => {
              this.closeModal();
            })
            .catch(() => {
              this.errorMessage =
                "Une erreur est survenue lors de l'édition du moyen de communication, veuillez réessayer ou contacter le support.";
            });
        } else {
          this.errorMessage = 'Veuillez corriger les erreurs.';
        }
      });
    },
    deleteMocButtonClicked() {
      this.errorMessage = null;

      swal({
        title: 'Êtes-vous sûr de vouloir supprimer ce moyen de communication ?',
        text: "Il ne sera pas possible d'annuler cette suppression",
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Oui, effacer',
        cancelButtonText: 'Non, conserver',
        buttonsStyling: false,
      })
        .then(() => {
          this.$http
            .delete(
              `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/${this.type}/telecominfos/${this.meanOfTelecom.id}`,
            )
            .then(response => {
              this.closeModal();
            })
            .catch(error => {
              this.errorMessage =
                'Une erreur est survenue lors de la suppression du moyen de communication, veuillez réessayer ou contacter le support.';
            });
        })
        .catch(() => {});
    },
    closeModal() {
      this.$emit('close');
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.validation-error {
  color: red;
  margin-bottom: 1em;
}
</style>
